import { useCallback, useEffect, useState } from "react";
import merge from "lodash.merge";

export enum EntryStatus {
  Incomplete,
  InProgress,
  Complete,
}

export type EntryState = {
  status: EntryStatus;
  data: Record<string, string[]>;
};

const useEntryState = (entryId: string | undefined) => {
  const [data, update] = useState<EntryState | null>(null);
  const setData = useCallback(
    (updated: Partial<EntryState>) => {
      update((current) => {
        return merge({}, current, updated);
      });
    },
    [update]
  );

  useEffect(() => {
    if (entryId) {
      if (!data) {
        const fromStorage = JSON.parse(localStorage.getItem(entryId) || "{}");
        // Migrate data from v1 structure
        if (Object.keys(fromStorage).length > 0 && !fromStorage.data) {
          setData({ data: fromStorage });
        } else {
          setData(fromStorage);
        }
      } else if (Object.keys(data).length > 0) {
        localStorage.setItem(entryId, JSON.stringify(data));
      }
    }
  }, [entryId, data, setData]);

  return { data, setData };
};

export default useEntryState;
